<template>
  <Dialog :type="4" @close="$emit('close')">
    <div :class="['key-dialog', 'key-dialog-' + dialogClass]">
      <div
        :class="[
          'key-sum',
          'key-sum-' + (lotteryInfo.category ? 'gold' : 'diamond')
        ]"
      >
        X{{ lotteryInfo.num }}
      </div>
      <img class="btn-open" @click="open" src="./img/key/btn-open.png" />
    </div>
  </Dialog>
</template>

<script>
// 推送type是get_lottery，数据是{"event":"login","num":3,"category":1,"activity_id}
// num ：发放数量
// event有三种：login登录、 注册、finishOrder完成订单，分别对应这3个弹窗事件
// category有2种 ： 1:黄金；2:钻石
// activity_id活动id
import Dialog from "./Dialog.vue";

export default {
  components: { Dialog },
  props: {
    lotteryInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    dialogClass() {
      if( this.lotteryInfo.event === 'finishOrder' ) {
        return this.lotteryInfo.category === 1 ? 'gold' : 'diamond'
      }
      return this.lotteryInfo.event
    },
    // sumClass() {
    //   if( lotteryInfo.event === 'finishOrder' ) {
    //     return lotteryInfo.category
    //   }
    //   return lotteryInfo.event
    // }
  },
  methods: {
    open() {
      this.$emit('close')
      const { event, num, category, activity_id } = this.lotteryInfo;
      this.$router.push({
        path: "/xx-having-you",
        query: {
          event,
          num,
          category,
          a_id: activity_id
        }
      });
    }
  }
};
</script>

<style lang="less">
.key-dialog {
  width: 700px;
  height: 700px;
  background-size: 100% 100%;
  position: relative;
  &-login {
    background: url(./img/key/login-bg.png);
  }
  &-register {
    background: url(./img/key/register-bg.png);
  }
  &-diamond {
    background: url(./img/key/diamond-bg.png);
  }
  &-gold {
    background: url(./img/key/gold-bg.png);
  }
  .key-sum {
    position: absolute;
    top: 458px;
    left: 420px;
    font-size: 42px;
    &-diamond {
      color: #e9a5e4;
    }
    &-gold {
      color: #fde04d;
    }
  }
  .btn-open {
    width: 181px;
    height: 53px;
    position: absolute;
    top: 570px;
    left: 254px;
  }
}
</style>
